/**
 * Block is used on
 *
 * @returns {{init(): void, changeCategory(*): void, topics: [], categories: [], activeTopics: [], activeCategory: number}}
 */
export default () => ({
    activeCategory: 0,
    categories: [],
    topics: [],
    activeTopics: [],

    init() {
        let ref = this;

        fetch(hch_theme_ajax_endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
            },
            body: 'action=hch_init_faqs',
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then((data) => {
                if (data.data.categories.length > 0 && Array.isArray(data.data.categories)) {
                    data.data.categories.forEach(function (post, index) {
                        ref.categories.push({
                            id: post.term_id,
                            name: post.name
                        })
                    });
                }

                data.data.results.forEach(function (post, index) {
                    ref.topics.push({
                        id: post.id,
                        title: post.title,
                        content: post.content,
                        category: parseInt(post.category),
                        state: post.state
                    })
                });

                if (ref.categories.length > 0) {
                    ref.activeCategory = ref.categories[0].id;
                }

                ref.activeTopics = this.topics.filter(x => x.category === this.activeCategory);
            })
            .catch((error) => {
                console.error(error);
            });
    },

    changeCategory(id) {
        this.activeCategory = id;
        this.activeTopics = [];

        let ref = this;

        fetch(hch_theme_ajax_endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
            },
            body: 'action=hch_fetch_faq_topics&term_id=' + id,
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then((data) => {
                ref.topics = [];

                data.data.results.forEach(function (post, index) {
                    ref.topics.push({
                        id: post.id,
                        title: post.title,
                        content: post.content,
                        category: parseInt(post.category),
                        state: post.state
                    })
                });

                ref.activeTopics = this.topics.filter(x => x.category === this.activeCategory);
            })
            .catch((error) => {
                console.error(error);
            });
    }
})
